import getTableConversationRelation from './getTableConversationRelation';
/**
 * Filters a collection of rowKeys from a given tableView and returns rowKeys for the ones that meet the given customRestriction.
 * @param rowKeys - the given conversation rowKeys
 * @param tableViewId - the table view id that these conversations belong to (or null if we don't care)
 * @param customRestriction - a callback that returns a boolean flag for filtering conversations (true- keep; false- throw away)
 * @param optionalArgs - optional args that used by customRestriction
 * @returns a filtered colllection of conversationIds
 */
export default function filterConversationRowsByRestriction(rowKeys, tableViewId, customRestriction, optionalArgs) {
    var rowKeysToReturn = [];
    var rowIdsVisited = new Map();
    for (var i = 0; i < rowKeys.length; i++) {
        var rowKey = rowKeys[i];
        var tableConversationRelation = getTableConversationRelation(rowKey, tableViewId);
        // Check if the relation meets the custom restriction and
        // also de-dup the rows (multi-value sorted tables have rows with same rowIds)
        var rowId = tableConversationRelation.id;
        if (!rowIdsVisited.get(rowId) &&
            customRestriction(tableConversationRelation, optionalArgs)) {
            rowKeysToReturn.push(rowKey);
            rowIdsVisited.set(rowId, true);
        }
    }
    return rowKeysToReturn;
}
//# sourceMappingURL=filterConversationRowsByRestriction.js.map